import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class HtmlHelperService {

  toEncodedHtml(input: any): any {
    input = input ?? null;
    if (input instanceof Array) {
      return input.map(item => this.toEncodedHtml(item));
    }
    if (input !== null && typeof input === 'object') {
      const object = {};
      for (var propertyName in input) {
        object[propertyName] = this.toEncodedHtml(input[propertyName]);
      }
      return object;
    }
    return input?.toString()?.replace(/[\u00A0-\u9999<>\&]/g, s => `&#${s.charCodeAt(0)};`);
  }

  toEncodedHtmlLineBreaks(input: string): string {
    return input?.replace(/\n/g, '<br>');
  }

  formatHtml(tag: string, innerHtml: string): string {
    return `<${tag}>${innerHtml ?? ''}</${tag}>`;
  }

  formatHtmlList(tag: string, itemTag: string, items: string[]): string {
    return this.formatHtml(tag, items?.map(item => this.formatHtml(itemTag, item))?.join(''));
  }

  formatHtmlTable(headerRow: string[], dataRows: string[][], border = 0): string {
    const html: string[] = [];
    html.push(`<table border="${border}">`);
    html.push('<thead>');
    html.push('<tr>');
    for (const cell of headerRow ?? []) {
      html.push(this.formatHtml('th', cell));
    }
    html.push('</tr>');
    html.push('</thead>');
    html.push('<tbody>');
    for (const dataRow of dataRows ?? []) {
      html.push('<tr>');
      for (const cell of dataRow ?? []) {
        html.push(this.formatHtml('td', cell));
      }
      html.push('</tr>');
    }
    html.push('</tbody>');
    html.push('</table>');
    return html.join('');
  }

  static readonly fieldNameTag = 'b';
  static readonly fieldValueTag = 'i';
  static readonly listTag = 'ul';
  static readonly listItemTag = 'li';

  formatFieldName(name: string): string {
    return this.formatHtml(HtmlHelperService.fieldNameTag, name);
  }

  formatFieldValue(value: string): string {
    return this.formatHtml(HtmlHelperService.fieldValueTag, value);
  }

  formatField(field: { name: string, value: string }): string {
    return `${this.formatFieldName(field?.name)}: ${this.formatFieldValue(field?.value)}`;
  }

  formatFieldValues(values: string[]): string {
    return this.formatHtmlList(HtmlHelperService.listTag, HtmlHelperService.listItemTag, values?.map(value => this.formatFieldValue(value)));
  }

  formatFields(fields: { name: string, value: string }[]): string {
    return this.formatHtmlList(HtmlHelperService.listTag, HtmlHelperService.listItemTag, fields?.map(field => this.formatField(field)));
  }

  createField(name: string, value: string): { name: string, value: string } {
    return { name, value };
  }

  createFieldFromPropertyName(object: any, propertyName: string): { name: string, value: string } {
    return this.createField(propertyName, object?.[propertyName]?.toString());
  }

  setFocusToHtmlElementByClassName(className: string, delayMs = 0): void {
    this.setFocusToHtmlElement(() => document.getElementsByClassName(className)?.[0] as HTMLElement, delayMs);
  }

  setFocusToHtmlElement(getHtmlElement: () => HTMLElement, delayMs = 0): void {
    setTimeout(
      () => {
        const element = getHtmlElement();
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'center' });
          element.focus({ preventScroll: true });
        }
      },
      delayMs);
  }
}
